<template>
    <div class="news-item">
        <div class="the-image">
            <router-link :to="`/blog/${item.ID}`" class="image-fit">
                <img
                    v-if="!item.image"
                    src="../assets/images/news1.jpg"
                    alt=""
                />
                <img v-if="item.image" :src="item.image" alt="" />
            </router-link>
        </div>
        <div class="info font-bai">
            <h3 class="font-balo font-bold">
                <router-link :to="`/blog/${item.ID}`">{{
                    item.title
                }}</router-link>
            </h3>
            <div class="des" v-html="item.des"></div>
            <div class="font-balo date">
                <b>{{ formatDate() }}</b>
            </div>
        </div>
    </div>
</template>

<script>
import moment from "moment";
export default {
    name: "NewsItem",
    props: ["item"],
    methods: {
        formatDate() {
            return moment(this.item.date).format("DD.MM.YY");
        }
    }
};
</script>
